<template>
  <div class="register-detail-page">
    <a-card class="register-detail-card">
      <div class="register-detail-title">
        <div> {{ registerTile }}</div>
        <div style="font-size: 14px;color: #999999;">{{ $t('registerCheckHint') }}</div>
      </div>
      <a-alert type="error">
        <template slot="message">
          <div class="a-alert-text">{{ $t('currentStatus') }}:
            <span>{{ userInfo ? $dt(userInfo, 'OPER_STATUS_NAME') : '用户' }} <span v-if="userInfo?.OPER_STATUS === 20031004">({{ userInfo?.RET_DESC }})</span></span>
          </div>
        </template>
      </a-alert>

      <a-row class="register-detail-row" type="flex">
        <a-col class="register-detail-col" flex="100px">
          {{ $t('通用_企业名称') }}:
        </a-col>
        <a-col flex="auto">
          {{ userInfo?.COMPANY_NAME }}
        </a-col>
      </a-row>
      <a-row class="register-detail-row" type="flex">
        <a-col class="register-detail-col" flex="100px">
          {{ $t('contact') }}:
        </a-col>
        <a-col flex="auto">
          {{ userInfo?.USER_NAME }}
        </a-col>
      </a-row>
      <a-row class="register-detail-row" type="flex">
        <a-col class="register-detail-col" flex="100px">
          {{ $t('mobile') }}:
        </a-col>
        <a-col flex="auto">
          {{ userInfo?.MOBILE }}
        </a-col>
      </a-row>
      <a-row class="register-detail-row" type="flex">
        <a-col class="register-detail-col" flex="100px">
          {{ $t('businessAddressDetails') }}:
        </a-col>
        <a-col flex="auto">
          {{ userInfo?.ADDRESS }}
        </a-col>
      </a-row>
      <a-row class="register-detail-row" type="flex">
        <a-col class="register-detail-col" flex="100px">
          {{ $t('businessLicense') }}:
        </a-col>
        <a-col flex="auto">
          <div v-for="(item,index) in imgList" :key="index">
            <div v-if="fileTypeList.indexOf(item.FILE_TYPE.toLowerCase()) !== -1">
              <dol-image-list-preview :imageList="[item]"></dol-image-list-preview>
            </div>
            <a :href="$Dolphin.path.filePath+item.FILE_NAME" target="_blank" v-else>
              {{ item.ORGI_FILE_NAME }}
            </a>
          </div>
<!--            <div v-if="fileTypeList.indexOf(imgList?.[0]?.FILE_TYPE.toLowerCase()) !== -1">
              <dol-image-list-preview :imageList="imgList"></dol-image-list-preview>
            </div>
            <a v-else @click="downFile(item)">
              <a-space>
                <a-icon type="vertical-align-bottom"/>
                <div>{{ item.ORGI_FILE_NAME }}</div>
              </a-space>
            </a>-->
<!--          <dol-image-list-preview :imageList="imgList"/>-->
        </a-col>
      </a-row>

      <div class="register-detail-button">
        <a-button @click="$router.push('companyRegister')" v-if="userInfo?.OPER_STATUS === 20031004" type="primary">
          {{ $t('resubmit') }}</a-button>
      </div>
    </a-card>
  </div>

</template>

<script>
import loginHeader from '../../components/common/login-header';
export default {
  name: "registerDetail",
  components:{loginHeader},
  data(){
    return{
      imgList:[],
      fileTypeList: ['.png', '.jpg', '.jpeg', '.bmp', '.gif', '.webp', '.psd', '.svg', '.tiff'],
    }
  },
  computed:{
    userInfo(){
      return this.$store?.state?.userInfo;
    },
    fileList(){
      return this.$store?.state?.fileList;
    },
    registerTile(){
      if(this.userInfo?.OPER_STATUS === 20031004){
        return this.$t('registerCheckReject')
      }else {
        return this.$t('registerChecking')
      }
    },
    sysType(){
      let type='' ;
      this.$store?.state?.sysList?.forEach(item=>{
        if(item.SYS_CODE === 20011002 ){
          type = item;
        }
      })
      return type
    },
  },
  methods:{
    downFile(data) {
      this.$Dolphin.download(data.ORGI_FILE_NAME, this.$Dolphin.path.filePath + data.FILE_NAME)
    },
  },
  created() {
    if(this.userInfo?.OPER_STATUS === 20031002){
      this.$store.dispatch("autoLoginById",this.userInfo.USER_ID);
    }
    if(this.fileList){
      this.fileList.forEach(item =>{
        if(item.SYS_TYPE === 20011002 || item.SYS_TYPE === 20011003){
          this.imgList.push(item)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .register-detail-page{
    //background-color: #F5F7F9;

    .register-detail-card{
      padding: 8px 180px;
      width: 990px;
      margin: 24px auto;

      .register-detail-title{
        text-align: center;
        margin-bottom: 32px;
        font-size: 24px;
        font-weight: 700;
        color: #333333;
        line-height: 33px;
      }

      .a-alert-text{
        text-align: center;
        span{
          color: #FB8E23;
        }
      }

      .register-detail-row{
        margin-top: 24px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        .register-detail-col{
          text-align: right;margin-right: 16px;
        }
      }

      .register-detail-button{
        margin-top: 50px;
        text-align: center;
      }
    }
  }
</style>